module.exports = __webpack_public_path__ + "img/Slice 18@2x (1).8148f29b.png";